import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "sparkline_container",
  ref: "chartRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.visible && _ctx.series)
      ? (_openBlock(), _createBlock(_component_apexchart, {
          type: _ctx.chartType,
          height: "100%",
          width: "100%",
          ref: "chart",
          key: _ctx.chartKey,
          options: _ctx.chartOptions,
          series: _ctx.series
        }, null, 8, ["type", "options", "series"]))
      : _createCommentVNode("", true)
  ], 512))
}